(function($) {

    //console.log(site_data.SPEEDBUMP_WHITELIST);

    $("a[href^='http://'],a[href^='https://']").click(function (e) {
        var blnSafe = false;
        var arrSafe = site_data.SPEEDBUMP_WHITELIST.split(',');
        // var arrSafe = ['americascreditunion.lndo','pantheonsite.io','youracu.org','mymortgage-online.com'];
        var curSafe = $(this).attr('href');
        for (var x = 0; x < arrSafe.length; x++) {
            if (curSafe.indexOf(arrSafe[x]) >= 0) {
                blnSafe = true;
            }
        }

        if (!blnSafe) {
            e.preventDefault();

            var theURL = $(this).attr('href');
            var targetWin = $(this).attr('target') ? $(this).attr('target') : '_blank';
            var targetUrl = $(this).attr('href');
            $('#popup-speedbump .btn').attr('href', targetUrl).attr('target', targetWin);

            $.magnificPopup.open({
                items: {
                    type: 'inline',
                    src: '#popup-speedbump',
                },
                removalDelay: 500,
                fixedContentPos: true,
                mainClass: 'mfp-fade',
                showCloseBtn: false,
                modal: true
            });
            $(document).on('click', '.continue-popup-close', function (e) {
        		$.magnificPopup.close();
        	});
            $(document).on('click', '.popup-close', function (e) {
        		e.preventDefault();
        		$.magnificPopup.close();
        	});


        }
    });

})(jQuery);
